exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.container[data-v-5b82c05a] {\n  padding: 16px;\n}\np[data-v-5b82c05a] {\n  margin: 0;\n}\n", "", {"version":3,"sources":["/opt/build/repo/src/components/Professionals/Edit/Tabs/Register/Steps/src/components/Professionals/Edit/Tabs/Register/Steps/Created.vue"],"names":[],"mappings":";AAWA;EACA,cAAA;CACA;AAEA;EACA,UAAA;CACA","file":"Created.vue","sourcesContent":["<template>\n  <div class=\"container\">\n    <p>\n      O profissional criou o seu cadastro e se encontra na fase de treinamento.\n      Quando ele finalizar o treinamento e for aprovado será movido\n      automaticamente no fluxo para a próxima etapa de envio de documentos.\n    </p>\n  </div>\n</template>\n\n<style scoped>\n.container {\n  padding: 16px;\n}\n\np {\n  margin: 0;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b82c05a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Professionals/Edit/Tabs/Register/Steps/Created.vue
// module id = IvKx
// module chunks = 1